import * as React from 'react';
import Paper from '@material-ui/core/Paper';
import {
    ArgumentAxis,
    ValueAxis,
    Chart,
    LineSeries,
    SplineSeries,
} from '@devexpress/dx-react-chart-material-ui';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core';

export default function SpeedChart(props) {

    const classes = useStyles();

    const generateData = (start, end, step) => {
        const data = [];
        const time = ["08:30","09:00","09:30","10:00","10:30","11:00","11:30","12:00","12:30","13:00"]
        const speedValues = [400,560,550,700,650,700,800,500,670,450,250,400,300,600,700,800,850,450,700,550]

        for (let i = start; i < end; i += step) {
            data.push({ averageProductionValue: 600, productionValue: speedValues[i], ybottom: 0,yceiling:1000, time: time[i] });
        }

        return data;
    };

    const [chartData, setChartData] = useState(generateData(0, 10, 0.5))

    return (
        <div className={classes.speedChart}>
            <div className={classes.title}>
                Throughput
            </div>
            <Chart
                data={chartData}
            >
                <ArgumentAxis />
                <ValueAxis />

                <LineSeries
                    name="line"
                    valueField="productionValue"
                    argumentField="time"
                />
                <LineSeries
                    name="line"
                    valueField="averageProductionValue"
                    argumentField="time"
                />
                <LineSeries
                    name="line"
                    valueField="ybottom"
                    argumentField="time"
                    color="rgb(1,1,1,0)"
                />
                  <LineSeries
                    name="line"
                    valueField="yceiling"
                    argumentField="time"
                    color="rgb(1,1,1,0)"
                />
                {/* <SplineSeries
                    name="spline"
                    valueField="splineValue"
                    argumentField="argument"
                /> */}
            </Chart>
        </div>
    );

}

const useStyles = makeStyles({
    speedChart: {
        height: "520px",
        padding: "20px",
        backgroundColor: "white",
        borderRadius: "6px",
        marginBottom: "10px",
        paddingBottom: "40px",
        overflow: "hidden",
        paddingRight: "0px",
        borderRight: "40px solid white",

    },
    title: {
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#8D8D8D',
        marginBottom: "30px"
    },
})
